
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_493_1035)"}},[_c('path',{attrs:{"d":"M10 0C4.477 0 0 4.48 0 10.006c0 5.525 4.477 10.006 10 10.006s10-4.48 10-10.006S15.523 0 10 0zm4.881 7.52s.238 1.179-.615 3.25c-.854 2.071-2.965 4.03-5.874 4.213-2.91.181-4.476-1.106-4.476-1.106 2.182.168 3.147-.728 3.664-1.022-2.028-.266-2.322-1.791-2.322-1.791.196.084.797.056 1.12-.028-1.987-.49-2.029-2.49-2.029-2.49s.741.377 1.161.307c-1.916-1.455-.797-3.359-.797-3.359C7.245 8.265 9.93 8.111 9.93 8.111l.012.019a2.508 2.508 0 014.28-2.304l.016-.01c.895-.056 1.553-.532 1.553-.532a2.285 2.285 0 01-1.094 1.293.62.62 0 01.01.022 49.82 49.82 0 001.377-.349c-.49.896-1.203 1.27-1.203 1.27z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_493_1035"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    